export default __webpack_public_path__ + "b9f5a677ff7ee79c93584bb942717d69.png";